import type { MfaActivationData, MfaUpdateCredentials, ValidOtp } from '../../domain'

export interface MfaService {
    /**
     * Yields if the user has mfa enabled or not
     * @throws {import('../../domain').ConnectwareError}
     */
    isEnabled(): Promise<boolean>

    /**
     * Starts the enabling process
     * @throws {import('../../domain').ConnectwareError}
     */
    enable(): Promise<MfaActivationData>

    /**
     * Finishes the enabling process
     * @throws {import('../../domain').ConnectwareError}
     * @returns backup codes
     */
    confirmEnabling(otp: ValidOtp): Promise<readonly string[]>

    /**
     * With the given credentials, attempts to disable MFA
     * @throws {import('../../domain').ConnectwareError}
     */
    disable(credentials: MfaUpdateCredentials): Promise<void>

    /**
     * With the given credentials, attempts to regerate backup codes
     * @throws {import('../../domain').ConnectwareError}
     */
    regenerateBackupCodes(credentials: MfaUpdateCredentials): Promise<readonly string[]>
}
